// @flow
import { itemClicked, type itemClickedType } from './analyticsHelpers';

const activityLocation = '<<attributes.data-track-activity-location.value>>';
const otherProps = {
  serviceProviderId: '<<attributes.data-track-service-provider-id.value>>',
};

export default {
  elements: {

    'business-info--review-count-link': (itemClicked(activityLocation, 'Total Reviews', otherProps): itemClickedType),

    'business-info--business-list-link-*': (itemClicked(activityLocation, 'Business List', otherProps): itemClickedType),

    'business-info--business-list-name-link-*': (itemClicked(activityLocation, 'Business Name - Global Nav', otherProps): itemClickedType),

    'business-nav--home-*': (itemClicked(activityLocation, 'Home Icon', otherProps): itemClickedType),

    'business-nav--leads-*': (itemClicked(activityLocation, 'Leads Icon', otherProps): itemClickedType),

    'business-nav--messages-*': (itemClicked(activityLocation, 'Messages Icon', otherProps): itemClickedType),

    'business-nav--view-reviews-*': (itemClicked(activityLocation, 'View Reviews', otherProps): itemClickedType),

    'business-nav--request-reviews-*': (itemClicked(activityLocation, 'Click Request Reviews Link', otherProps): itemClickedType),

    'business-nav--my-business-*': (itemClicked(activityLocation, 'My Business', otherProps): itemClickedType),

    'business-nav--business-profile-*': (itemClicked(activityLocation, 'Business Profile', otherProps): itemClickedType),

    'business-nav--categories-*': (itemClicked(activityLocation, 'Categories', otherProps): itemClickedType),

    'business-nav--service-areas-*': (itemClicked(activityLocation, 'Service areas', otherProps): itemClickedType),

    'business-nav--associates-*': (itemClicked(activityLocation, 'Associates', otherProps): itemClickedType),

    'business-nav--manage-agreements-*': (itemClicked(activityLocation, 'Manage Agreements', otherProps): itemClickedType),

    'business-nav--quick-books-online-sync-*': (itemClicked(activityLocation, 'QuickBooks Online Sync', otherProps): itemClickedType),
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/businessInfoPanelAnalytics.js